<template>
  <div id="func-51">
    <funcionalidade-header :titulo="tituloNavegacao" :voltar="!isWidget"/>
    <div class="main">
      <SolicitacaoListagem
        :funcionalidade="funcionalidade"
        :rota-detalhe="rotaDetalhe"
        :rota-historico="rotaHistorico"
        :rota-novo="rotaNovo"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoListagem from '@/components/TemplateSolicitacao/SolicitacaoListagem'

export default {
  components: { SolicitacaoListagem, FuncionalidadeHeader },
  data () {
    return {
      contratosList: []
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade']),
    ...mapGetters('Login', ['user', 'contratos']),
    ...mapGetters('SetupApp', ['configuracaoAcesso', 'isWidget']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    rotaHistorico () {
      return `/${this.funcionalidade.idFuncionalidade}/historico`
    },
    rotaDetalhe () {
      return `/${this.funcionalidade.idFuncionalidade}/detalhe`
    },
    rotaNovo () {
      return `/51/novo`
    }
  }
}
</script>
<style
  lang="less"
>
#func-51 {
  .sub {
    font-size: 11px;
    color: #555555;
    margin: 0;
    font-weight: 400;
  }

  .main {
    margin-top: 30px;
    padding: 0 15px 20px;
  }

  .listagem-extrato-reembolso {
    border-left: 5px solid var(--situacao-cor);
    border-radius: 6px;
  }

  .situacao-card {
    color: var(--situacao-cor)
  }
}
</style>
